import React, { useContext } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/Avatar';
import { SessionContext } from '../contexts/SessionContext';
import { generateColor } from '../utils';
import { APIContext } from '../contexts/APIContext';

// Component to show the ACN logo as the bot's Avatar
const CustomAvatar = (props: any) => {
  const { userAvatar } = props;
  const { accountDetails } = useContext(SessionContext);
  const {
    userDetails: { User_ProfileImage: profileImg },
  } = useContext(APIContext);

  const avatar = !accountDetails.initials ? (
    <img src="/icons/avatar.svg" alt="avatar" />
  ) : (
    <Avatar className="w-8 h-8 text-sm">
      <AvatarImage src={`data:image/jpeg;base64,${profileImg?.result}`} className="AvatarImage"></AvatarImage>
      <AvatarFallback>{accountDetails.initials}</AvatarFallback>
    </Avatar>
  );

  return userAvatar ? (
    <div className="react-chatbot-kit-user-avatar flex justify-center items-center">
      <div className="react-chatbot-kit-user-avatar-container">
        <div
          className="rounded-full text-white"
          style={{ backgroundColor: generateColor(accountDetails.initials ?? '..') }}
        >
          {avatar}
        </div>
      </div>
    </div>
  ) : (
    <div className="react-chatbot-kit-chat-bot-avatar">
      <div className="react-chatbot-kit-chat-bot-avatar-container">
        <img width="24" height="24" src="/icons/Frame.svg" alt="bot icon"></img>
      </div>
    </div>
  );
};

export default CustomAvatar;
